import PublicBookingPage from './PublicBookingPage';
import { PublicOrgRouteShell } from '@/components/public/PublicOrgRouteShell';

/** `/club-academy/:slug/book/:lessonId/*` — public booking wizard inside unified org shell. */
export default function OrgPublicBookingRoute() {
  return (
    <PublicOrgRouteShell>
      <PublicBookingPage suppressPublicChrome />
    </PublicOrgRouteShell>
  );
}
